document.querySelectorAll('.product-gallery-custom').forEach((gallery) => {
  const slides = Array.from(gallery.querySelectorAll('.product-gallery-custom__slide'));
  const thumbs = Array.from(gallery.querySelectorAll('.product-gallery-custom__thumb'));

  function isVisible(el) {
    return !el.classList.contains('is-hidden-for-variant');
  }

  function setActive(index) {
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    const activeThumb = thumbs[index];
    if (activeThumb) {
      activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  function setActiveByMediaId(mediaId) {
    if (!mediaId) return false;
    const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
    if (index !== -1) {
      setActive(index);
      return true;
    }
    return false;
  }

  function setActiveFirstVisible() {
    const index = slides.findIndex((slide) => isVisible(slide));
    if (index !== -1) setActive(index);
  }

  function filterForVariant(variantId) {
    if (!variantId) return;
    const idStr = String(variantId);

    slides.forEach((slide, i) => {
      const variantIds = slide.dataset.variantIds || '';
      const isGeneral = variantIds === '';
      const matchesVariant = variantIds.split(',').includes(idStr);
      const hidden = !isGeneral && !matchesVariant;
      slide.classList.toggle('is-hidden-for-variant', hidden);
      if (thumbs[i]) thumbs[i].classList.toggle('is-hidden-for-variant', hidden);
    });
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => setActive(i));
  });

  if (slides.length > 1) setActiveFirstVisible();

  const sectionId = gallery.dataset.section;
  if (sectionId && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId: changedSectionId, variant } }) => {
      if (changedSectionId !== sectionId || !variant) return;

      filterForVariant(variant.id);

      const matched = variant.featured_media && setActiveByMediaId(variant.featured_media.id);
      if (!matched) setActiveFirstVisible();
    });
  }
});
